"use strict";
/*
 * This module imports and re-exports all Angular Material modules for convenience,
 * so only 1 module import is needed in your feature modules.
 * See https://material.angular.io/guide/getting-started#step-3-import-the-component-modules.
 *
 * To optimize your production builds, you should only import the components used in your app.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var table_1 = require("@angular/cdk/table");
var overlay_1 = require("@angular/cdk/overlay");
var material_1 = require("@angular/material");
var MaterialModule = /** @class */ (function () {
    function MaterialModule() {
    }
    MaterialModule = tslib_1.__decorate([
        core_1.NgModule({ imports: [
                // CDK
                table_1.CdkTableModule,
                overlay_1.OverlayModule,
                // Material
                material_1.MatAutocompleteModule,
                material_1.MatButtonModule,
                material_1.MatButtonToggleModule,
                material_1.MatCardModule,
                material_1.MatCheckboxModule,
                material_1.MatChipsModule,
                material_1.MatDatepickerModule,
                material_1.MatDialogModule,
                material_1.MatExpansionModule,
                material_1.MatGridListModule,
                material_1.MatIconModule,
                material_1.MatInputModule,
                material_1.MatListModule,
                material_1.MatMenuModule,
                material_1.MatProgressBarModule,
                material_1.MatProgressSpinnerModule,
                material_1.MatRadioModule,
                material_1.MatRippleModule,
                material_1.MatSelectModule,
                material_1.MatSidenavModule,
                material_1.MatSlideToggleModule,
                material_1.MatSliderModule,
                material_1.MatSnackBarModule,
                material_1.MatTabsModule,
                material_1.MatToolbarModule,
                material_1.MatTooltipModule,
                material_1.MatNativeDateModule,
            ],
            exports: [
                // CDK
                table_1.CdkTableModule,
                overlay_1.OverlayModule,
                // Material
                material_1.MatAutocompleteModule,
                material_1.MatButtonModule,
                material_1.MatButtonToggleModule,
                material_1.MatCardModule,
                material_1.MatCheckboxModule,
                material_1.MatChipsModule,
                material_1.MatDatepickerModule,
                material_1.MatDialogModule,
                material_1.MatExpansionModule,
                material_1.MatGridListModule,
                material_1.MatIconModule,
                material_1.MatInputModule,
                material_1.MatListModule,
                material_1.MatMenuModule,
                material_1.MatProgressBarModule,
                material_1.MatProgressSpinnerModule,
                material_1.MatRadioModule,
                material_1.MatRippleModule,
                material_1.MatSelectModule,
                material_1.MatSidenavModule,
                material_1.MatSlideToggleModule,
                material_1.MatSliderModule,
                material_1.MatSnackBarModule,
                material_1.MatTableModule,
                material_1.MatTabsModule,
                material_1.MatToolbarModule,
                material_1.MatTooltipModule,
                material_1.MatNativeDateModule,
            ]
        })
    ], MaterialModule);
    return MaterialModule;
}());
exports.MaterialModule = MaterialModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWF0ZXJpYWwubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWF0ZXJpYWwubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILHNDQUF5QztBQUN6Qyw0Q0FBb0Q7QUFDcEQsZ0RBQXFEO0FBQ3JELDhDQTZCMkI7QUF3RTNCO0lBQUE7SUFDQSxDQUFDO0lBRFksY0FBYztRQXRFMUIsZUFBUSxDQUFDLEVBQUMsT0FBTyxFQUFFO2dCQUNaLE1BQU07Z0JBQ04sc0JBQWM7Z0JBQ2QsdUJBQWE7Z0JBRWIsV0FBVztnQkFDWCxnQ0FBcUI7Z0JBQ3JCLDBCQUFlO2dCQUNmLGdDQUFxQjtnQkFDckIsd0JBQWE7Z0JBQ2IsNEJBQWlCO2dCQUNqQix5QkFBYztnQkFDZCw4QkFBbUI7Z0JBQ25CLDBCQUFlO2dCQUNmLDZCQUFrQjtnQkFDbEIsNEJBQWlCO2dCQUNqQix3QkFBYTtnQkFDYix5QkFBYztnQkFDZCx3QkFBYTtnQkFDYix3QkFBYTtnQkFDYiwrQkFBb0I7Z0JBQ3BCLG1DQUF3QjtnQkFDeEIseUJBQWM7Z0JBQ2QsMEJBQWU7Z0JBQ2YsMEJBQWU7Z0JBQ2YsMkJBQWdCO2dCQUNoQiwrQkFBb0I7Z0JBQ3BCLDBCQUFlO2dCQUNmLDRCQUFpQjtnQkFDakIsd0JBQWE7Z0JBQ2IsMkJBQWdCO2dCQUNoQiwyQkFBZ0I7Z0JBQ2hCLDhCQUFtQjthQUN0QjtZQUNELE9BQU8sRUFBRTtnQkFDTCxNQUFNO2dCQUNOLHNCQUFjO2dCQUNkLHVCQUFhO2dCQUViLFdBQVc7Z0JBQ1gsZ0NBQXFCO2dCQUNyQiwwQkFBZTtnQkFDZixnQ0FBcUI7Z0JBQ3JCLHdCQUFhO2dCQUNiLDRCQUFpQjtnQkFDakIseUJBQWM7Z0JBQ2QsOEJBQW1CO2dCQUNuQiwwQkFBZTtnQkFDZiw2QkFBa0I7Z0JBQ2xCLDRCQUFpQjtnQkFDakIsd0JBQWE7Z0JBQ2IseUJBQWM7Z0JBQ2Qsd0JBQWE7Z0JBQ2Isd0JBQWE7Z0JBQ2IsK0JBQW9CO2dCQUNwQixtQ0FBd0I7Z0JBQ3hCLHlCQUFjO2dCQUNkLDBCQUFlO2dCQUNmLDBCQUFlO2dCQUNmLDJCQUFnQjtnQkFDaEIsK0JBQW9CO2dCQUNwQiwwQkFBZTtnQkFDZiw0QkFBaUI7Z0JBQ2pCLHlCQUFjO2dCQUNkLHdCQUFhO2dCQUNiLDJCQUFnQjtnQkFDaEIsMkJBQWdCO2dCQUNoQiw4QkFBbUI7YUFDdEI7U0FDSixDQUFDO09BQ1csY0FBYyxDQUMxQjtJQUFELHFCQUFDO0NBQUEsQUFERCxJQUNDO0FBRFksd0NBQWMifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/material.module.ts
// module id = 70
// module chunks = 0